import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../authService/authentication.service';
import { UserPermissionService } from '../userPermission/user-permission.service';
import { GlobalConstants } from 'src/app/shared/services/constants/globalconstants';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserRoles } from 'src/app/data/models/user/users.model';

@Injectable({
    providedIn:
        'root'
})
export class EmulateUserService {
    public currentEmulatedSubject: BehaviorSubject<any>;
    public currentEmulation: Observable<any>;
    public menuItemsSubject: BehaviorSubject<any>;
    public menuItems: Observable<any>;
    public menus: any;
    currentUser: any;
    respondUser: any;

    constructor(
        private http: HttpClient,
        private authservice: AuthenticationService,
        public userPermissionService: UserPermissionService,
        private domSanitizer: DomSanitizer,
        private router: Router
    ) {
        this.currentEmulatedSubject = new BehaviorSubject<any>(
            JSON.parse(localStorage.getItem('emulatedUserStatus')) === 'true'
        );
        this.currentEmulation = this.currentEmulatedSubject.asObservable();
        this.authservice.currentUser.subscribe(user => this.currentUser = user);
        this.authservice.respondUser.subscribe(respondUser => this.respondUser = respondUser);
        this.menuItemsSubject = new BehaviorSubject<any>(
            this.menuData
        );
        this.menuItems = this.menuItemsSubject.asObservable();
    }

    public get CurrentEmulationValue() {
        return this.currentEmulatedSubject;
    }

    public get menuItemsData() {
        return this.menuItemsSubject;
    }

    getMenuItems(username: string, emailid: string) {
        const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
        const formattedUsername = `<div class="d-block"><div style='line-height: 1.3;'>${username ?? ''}</div><div title="${emailid}" style='line-height: 1.3;width: 160px;font-size: 12px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;'>${emailid ?? ''}</div></div>`;

        this.menus = [
            {
                text: formattedUsername,
                id: GlobalConstants.RightMenuUsernameId,
                iconCss: ''
            },
            {
                text: 'Profile',
                id: GlobalConstants.RightMenuProfileId,
                iconCss: 'e-menu-icon e-icons e-person'
            },
            {
                text: 'Change Password',
                id: GlobalConstants.RightMenuChangePasswordId,
                iconCss: 'e-menu-icon e-icons e-key'
            },
            {
                text: 'User Access Log',
                id: GlobalConstants.RightMenuUserAccessLogId,
                iconCss: 'e-menu-icon e-icons e-learner-dash'
            },
            {
                text: 'Logout',
                id: GlobalConstants.RightMenuLogoutId,
                iconCss: 'e-menu-icon e-icons e-logout'
            }
        ];

        const indexOfPasswordItemInRightMenu = this.menus.findIndex(x => x.id == GlobalConstants.RightMenuChangePasswordId);
        if (!isUserOfTypeCMS) {
            return this.menus = [
                {
                    text: formattedUsername,
                    id: GlobalConstants.RightMenuUsernameId,
                    iconCss: ''
                },
                {
                    text: 'Logout',
                    id: GlobalConstants.RightMenuLogoutId,
                    iconCss: 'e-menu-icon e-icons e-logout'
                }
            ];
        }
        else {
            if (this.currentUser && this.currentUser.UserRoleID == UserRoles.Investigator) {
                const indexOfUserAccessLogItemInRightMenu = this.menus.findIndex(x => x.id == GlobalConstants.RightMenuUserAccessLogId);
                this.menus.splice(indexOfUserAccessLogItemInRightMenu, 1);
            }
        }

        const currentEmulatedStatus = JSON.parse(localStorage.getItem('emulatedUserStatus')) === 'true';
        if (currentEmulatedStatus == true) {
            this.menus.splice(indexOfPasswordItemInRightMenu, 1);
        }

        if (this.isMineralOrgUser()) {
            const indexOfProfileItem = this.menus.findIndex(x => x.id == GlobalConstants.RightMenuProfileId);
            if (indexOfProfileItem > -1) {
                this.menus.splice(indexOfProfileItem, 1);
            }
            const indexOfChangePasswordItem = this.menus.findIndex(x => x.id == GlobalConstants.RightMenuChangePasswordId);
            if (indexOfChangePasswordItem > -1) {
                this.menus.splice(indexOfChangePasswordItem, 1);
            }
        }

        return this.menus;
    }

    private isMineralOrgUser(): boolean {
        return this.currentUser?.Company?.Subsidiary?.toLowerCase() === 'mn';
    }

    private get menuData() {
        const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
        if (isUserOfTypeCMS) {
            return this.getMenuItems(this.currentUser.FirstName, this.currentUser.UserEmail);
        }
        return this.getMenuItems(this.respondUser.CaseNumber, '');
    }

    EmulateUser(userId: number): Observable<any> {
        return this.http.post<any>('/authentication/impersonation', { userId })
            .pipe(map(user => {
                const userDetails = user as any;
                if (userDetails.Company.LogoImage) {
                    this.authservice.currentUserCompanyLogoSubject.next(this.convertImageByteToImage(userDetails.Company.LogoImage));
                    delete userDetails.Company.LogoImage;
                }
                localStorage.setItem('currentSelectedNode', 'Dashboard');
                localStorage.setItem('currentuser', JSON.stringify(userDetails));
                localStorage.setItem('emulatedUserStatus', JSON.stringify('true'));
                this.authservice.currentUserSubject.next(user);
                this.currentEmulatedSubject.next(true);
                this.menuItemsSubject.next(this.getMenuItems(user.FirstName, user.UserEmail));
                this.userPermissionService.setLogedInUserPermissions(this.currentUser, this.respondUser);
                this.userPermissionService.bindMenuItems(this.currentUser);
                return user;
            }));
    }

    StopEmulateUser(): Observable<any> {
        return this.http.post<any>('/authentication/stopImpersonation', {})
            .pipe(map(user => {
                const userDetails = user as any;
                if (userDetails.Company.LogoImage) {
                    this.authservice.currentUserCompanyLogoSubject.next(this.convertImageByteToImage(userDetails.Company.LogoImage));
                    delete userDetails.Company.LogoImage;
                }
                localStorage.setItem('currentSelectedNode', 'Dashboard');
                localStorage.setItem('currentuser', JSON.stringify(userDetails));
                localStorage.setItem('emulatedUserStatus', JSON.stringify('false'));
                this.authservice.currentUserSubject.next(user);
                this.userPermissionService.setLogedInUserPermissions(this.currentUser, this.respondUser);
                this.userPermissionService.bindMenuItems(this.currentUser);
                this.currentEmulatedSubject.next(false);
                this.menuItemsSubject.next(this.getMenuItems(user.FirstName, user.UserEmail));
                return user;
            }));
    }

    convertImageByteToImage(imageBytes: any) {
        if (imageBytes) {
            let image: any;
            image = this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + imageBytes);
            image = image.changingThisBreaksApplicationSecurity;
            return image;
        }
        return '';
    }
}

